<div class="overlay-backdrop" (click)="closeOverlay()">
  <button class="close-button" (click)="closeOverlay()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="overlay-content">
    <img [src]="imageUrl" alt="Full screen image">
  </div>
</div>
